import React, { useState, useMemo, useEffect } from "react";
import "../CSS/SemuaTenagaKesehatan.css";
import { FaSearch, FaFileAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function DokterParu() {
  const [query, setQuery] = useState("");
  const [filterSpesialisasi, setFilterSpesialisasi] = useState("");
  const [dokter, setDokter] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // ================= FETCH DATA =================
  useEffect(() => {
    const fetchDokter = async () => {
      try {
        const res = await fetch("https://api-tibismart.tifpsdku.com/api/dokter-paru");

        if (!res.ok)
          throw new Error("Gagal mengambil data dokter paru");

        const data = await res.json();
        setDokter(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDokter();
  }, []);

  // ================= FILTER =================
  const spesialisasiList = useMemo(() => {
    const s = new Set(dokter.map((d) => d.spesialisasi));
    return ["All", ...Array.from(s)];
  }, [dokter]);

  const filtered = useMemo(() => {
    return dokter.filter((row) => {
      const q = query.toLowerCase().trim();

      if (q) {
        const match =
          row.nama_lengkap.toLowerCase().includes(q) ||
          (row.email || "").toLowerCase().includes(q) ||
          (row.no_telepon || "").includes(q);

        if (!match) return false;
      }

      if (
        filterSpesialisasi &&
        filterSpesialisasi !== "All" &&
        row.spesialisasi !== filterSpesialisasi
      ) {
        return false;
      }

      return true;
    });
  }, [dokter, query, filterSpesialisasi]);

  // ================= PAGINATION =================
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;

  const currentRows = filtered.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.max(
    1,
    Math.ceil(filtered.length / rowsPerPage)
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [query, filterSpesialisasi]);

  // ================= DELETE =================
  const handleDelete = async (id, nama) => {
    const konfirmasi = window.confirm(
      `Apakah yakin ingin menghapus dokter paru ${nama}?`
    );

    if (!konfirmasi) return;

    try {
      const res = await fetch(
        `https://api-tibismart.tifpsdku.com/api/dokter-paru/delete/${id}`,
        {
          method: "DELETE",
        }
      );

      if (!res.ok) throw new Error();

      setDokter((prev) => prev.filter((d) => d.id !== id));

      alert("Data berhasil dihapus.");
    } catch (err) {
      alert("Gagal menghapus dokter.");
    }
  };

  // ================= VERIFIKASI =================
  const handleVerifikasi = async (id) => {
    try {
      const res = await fetch(
        `https://api-tibismart.tifpsdku.com/api/dokter-paru/verifikasi/${id}`,
        {
          method: "PUT",
        }
      );

      const data = await res.json();

      if (!res.ok) throw new Error(data.message);

      alert("Dokter berhasil diverifikasi.");

      setDokter((prev) =>
        prev.map((item) =>
          item.id === id
            ? { ...item, status_verifikasi: "TERVERIFIKASI" }
            : item
        )
      );
    } catch (err) {
      alert(err.message);
    }
  };

  // ================= TOLAK =================
  const handleTolak = async (id) => {
    try {
      const res = await fetch(
        `https://api-tibismart.tifpsdku.com/api/dokter-paru/tolak/${id}`,
        {
          method: "PUT",
        }
      );

      const data = await res.json();

      if (!res.ok) throw new Error(data.message);

      alert("Dokter berhasil ditolak.");

      setDokter((prev) =>
        prev.map((item) =>
          item.id === id
            ? { ...item, status_verifikasi: "DITOLAK" }
            : item
        )
      );
    } catch (err) {
      alert(err.message);
    }
  };

  // ================= DETAIL =================
  const handleDetailClick = (id) => {
    navigate(`/HalamanDetailDokterParu/${id}`);
  };

  if (loading) return <p>Loading data...</p>;

  return (
    <div className="data-tenaga-page">
      <div className="content-tenaga">
        <div className="filter-section">
          <div className="search-box">
            <FaSearch className="search-icon" />

            <input
              type="text"
              placeholder="Cari dokter paru..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>

          <select
            value={filterSpesialisasi}
            onChange={(e) => setFilterSpesialisasi(e.target.value)}
          >
            {spesialisasiList.map((s) => (
              <option key={s}>{s}</option>
            ))}
          </select>

        </div>

        <div className="table-wrapper">
          <table className="table-tenaga">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Dokter</th>
                <th>No STR</th>
                <th>No. TLP</th>
                <th>Email</th>
                <th>Spesialisasi</th>
                <th>Status</th>
                <th>Verifikasi</th>
                <th>Aksi</th>
              </tr>
            </thead>

            <tbody>

              {currentRows.map((r, idx) => (

                <tr key={r.id}>

                  <td>{indexOfFirstRow + idx + 1}</td>

                  <td>{r.nama_lengkap}</td>

                  <td>{r.no_str}</td>

                  <td>{r.no_telepon}</td>

                  <td>{r.email}</td>

                  <td>{r.spesialisasi}</td>

                  <td>
                    <span
                      className={
                        r.status_verifikasi === "TERVERIFIKASI"
                          ? "badge-verifikasi"
                          : r.status_verifikasi === "DITOLAK"
                            ? "badge-ditolak"
                            : "badge-menunggu"
                      }
                    >
                      {r.status_verifikasi}
                    </span>
                  </td>

                  <td>
                    {r.status_verifikasi === "PENDING" && (
                      <>
                        <button
                          className="btn-verifikasi"
                          onClick={() => handleVerifikasi(r.id)}
                        >
                          Verifikasi
                        </button>

                        <button
                          className="btn-tolak"
                          onClick={() => handleTolak(r.id)}
                        >
                          Tolak
                        </button>
                      </>
                    )}
                  </td>

                  <td className="aksi">
                    <button
                      className="btn-detail"
                      onClick={() => handleDetailClick(r.id)}
                    >
                      <FaFileAlt className="icon-detail" /> Detail
                    </button>

                    <button
                      className="btn-hapuspasien"
                      onClick={() =>
                        handleDelete(r.id, r.nama_lengkap)
                      }
                    >
                      Hapus
                    </button>
                  </td>

                </tr>

              ))}

            </tbody>

          </table>
        </div>

        <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Prev
          </button>

          {(() => {
            const pages = [];
            const maxVisible = 5;

            let start = Math.max(1, currentPage - 2);
            let end = Math.min(totalPages, start + maxVisible - 1);

            if (end - start < maxVisible - 1) {
              start = Math.max(1, end - maxVisible + 1);
            }

            if (start > 1) {
              pages.push(
                <button key={1} onClick={() => setCurrentPage(1)}>
                  1
                </button>
              );

              if (start > 2) {
                pages.push(<span key="dots1">...</span>);
              }
            }

            for (let i = start; i <= end; i++) {
              pages.push(
                <button
                  key={i}
                  className={currentPage === i ? "active" : ""}
                  onClick={() => setCurrentPage(i)}
                >
                  {i}
                </button>
              );
            }

            if (end < totalPages) {
              if (end < totalPages - 1) {
                pages.push(<span key="dots2">...</span>);
              }

              pages.push(
                <button
                  key={totalPages}
                  onClick={() => setCurrentPage(totalPages)}
                >
                  {totalPages}
                </button>
              );
            }

            return pages;
          })()}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>
        </div>

        <p className="footer-textsemua">
          © 2025 TibiSmart. All rights reserved.
        </p>

      </div>
    </div>
  );
}

export default DokterParu;